import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API_CP, erreur } from './constantes';

// conseil : undefined = chargement, null = pas encore créé, false = erreur
export const useConseil = (annee) => {
  const [conseil, setConseil] = useState(undefined);

  const recharger = useCallback(() => axios.get(API_CP(annee))
    .then(({ data }) => { setConseil(data); return data; })
    .catch((e) => { setConseil(e.response?.status === 404 ? null : false); return null; }), [annee]);

  useEffect(() => { setConseil(undefined); recharger(); }, [recharger]);

  const enregistrer = useCallback(async (champs, message = 'Enregistré') => {
    try {
      const { data } = await axios.put(API_CP(annee), champs);
      setConseil(data);
      if (message) toast.success(message);
      return data;
    } catch (e) {
      erreur(e, "Erreur d'enregistrement");
      return null;
    }
  }, [annee]);

  return { conseil, setConseil, recharger, enregistrer };
};
